export default "__VITE_ASSET__DQRNiG4h__"